import { defaultValue, usePatchFilter, useResetFilter, useFilter } from './context';
import ContentBoardStyled from '../../../components/ContentBoardStyled';
import StyledBoardHeader from '../../../components/StyledBoardHeader';
import SearchInput from '../../../components/Inputs/SearchInput';
import SelectInput from '../../../components/Inputs/SelectInput';
import { FiltersWrap } from '../../../components/Inputs/styles';
import useDealers from '../../../api/useDealers';
import { isEqual } from 'lodash';
import React from 'react';

export default function () {
  const patchFilter = usePatchFilter();
  const resetFilter = useResetFilter();
  const { dealers } = useDealers('');
  const filter = useFilter();

  return (
    <ContentBoardStyled css={{ minHeight: '130px', marginLeft: 0, marginTop: 0 }}>
      <StyledBoardHeader
        button={{
          name: 'Reset',
          handler: resetFilter
        }}
        disabledButton={isEqual(defaultValue, filter)}
      >
        FILTER
      </StyledBoardHeader>

      <FiltersWrap p={3}>
        <SearchInput
          label='VIN'
          placeholder='Enter VIN'
          value={filter?.vin || ''}
          onChange={(vin) => patchFilter({ vin })}
        />
        <SelectInput
          label={'Locations'}
          data={dealers}
          keys={{ id: 'hmsId', name: 'name', type: 'locations' }}
          selectedItems={filter.dealers}
          setSelectedItems={(dealers) => {
            patchFilter({ dealers: dealers.filter((d) => Boolean(d)) });
          }}
        />
        <SelectInput
          single={1}
          label={'Request channel'}
          clearOption={1}
          data={{
            items: [
              { label: 'API', value: 'api' },
              { label: 'API / AI', value: 'api_ai' },
              { label: 'MCP', value: 'mcp' }
            ]
          }}
          keys={{ id: 'value', name: 'label' }}
          selectedItems={filter.channel}
          setSelectedItems={(channel) => patchFilter({ channel })}
        />
        <SelectInput
          single={1}
          label={'Verification status'}
          clearOption={1}
          data={{
            items: [
              { label: 'Verified', value: 'verified' },
              { label: 'Not found', value: 'not_found' }
            ]
          }}
          keys={{ id: 'value', name: 'label' }}
          selectedItems={filter.status}
          setSelectedItems={(status) => patchFilter({ status })}
        />
      </FiltersWrap>
    </ContentBoardStyled>
  );
}
